<template>
  <div>
    <ApexChart
      height="319"
      type="line"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  props: {
    metrics: Array,
    dataFrom: String,
    graphOptions: Object,
  },
  data() {
    return {};
  },
  computed: {
    options() {
      let options = {...this.graphOptions};
      options.xaxis.categories = this.categories;
      options.yaxis.labels.formatter = function (value) {
        if (value === null) {
          return this.$t("heading.hosting.usage.graphs.noData");
        }
        return value.toFixed(2) + "%";
      };
      options.legend = {
        show: false
      };
      return options;
    },
    series() {
      return [
        {
          name: this.$t("heading.hosting.usage.graphs.usage"),
          data: this.data,
        },
      ];
    },
    data() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "cpu_percent") ? m.cpu_percent : null,
        });
      }
      return data;
    },
    categories() {
      let categories = [];
      for (let d of this.data) {
        categories.push(d.x);
      }
      return categories;
    },
  },
};
</script>